export default __webpack_public_path__ + "static/media/gallery_00.7682904d.jpg";